import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Masonry from "react-masonry-css";
import { Carousel } from "react-responsive-carousel";
import "./ProjectGallery.scss"; 
import projects from "../portfolio/projects.js"; 
import Title from "../ui-components/title/title";
import ModelViewerComponent from "../ui-components/arSliderViewer/ModelViewerComponent";
import ArrowNext from "../../assets/portfolio/arrow-next.png";
import ArrowPrev from "../../assets/portfolio/arrow-prev.png";

const ProjectGallery = () => {
  const { id } = useParams();
  const project = projects.find((project) => project.id === id); 

  const [showCarousel, setShowCarousel] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (showCarousel) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [showCarousel]);

  if (!project) {
    return <Title title="Projeto não existe." />;
  }

  const openCarousel = (index) => {
    setCurrentImageIndex(index);
    setShowCarousel(true);
  };

  const closeCarousel = () => {
    setShowCarousel(false);
  };

  const renderArrowPrev = (onClickHandler, hasPrev) =>
    hasPrev && (
      <button className="carousel-arrow prev" onClick={onClickHandler}>
        <img src={ArrowPrev} alt="Prev"/>
      </button>
    );

  const renderArrowNext = (onClickHandler, hasNext) =>
    hasNext && (
      <button className="carousel-arrow next" onClick={onClickHandler}>
        <img src={ArrowNext} alt="Next"/>
      </button>
    );

  return (
    <div id="project-gallery">
      <div className="wrapper">
        <Title title={project.title} />
        <h1>Imagens</h1>
        <hr/>
        <Masonry
          breakpointCols={{
            default: 3,
            1100: 3,
            700: 2,
            500: 1,
          }}
          className="my-masonry-grid"
          columnClassName="mint__gallery"
        >
          {project.images.map((image, index) => (
            <div key={index} onClick={() => openCarousel(index)}>
              <img className="grid-image" src={image} alt={`Project ${project.title} Slide ${index}`} />
            </div>
          ))}
        </Masonry>
        {project.modelType === "ar" && project.models && project.models.length > 0 && (
          <div className="ar-model-viewer">
            <h1>AR</h1>
            <hr/>
            <ModelViewerComponent models={project.models} />
          </div>
        )}
        

        {showCarousel && (
          <div className="modal">
            <div className="modal-content">
              <button
                onClick={closeCarousel}
                className="close-button"
                style={{ zIndex: 9999, fontSize: "25px" }}
              >
                X
              </button>
              <Carousel
                selectedItem={currentImageIndex}
                renderArrowPrev={renderArrowPrev}
                renderArrowNext={renderArrowNext}
                emulateTouch={true}
                useKeyboardArrows={true}
                showStatus={false}
              >
                {project.images.map((image, index) => (
                  <div key={index}>
                    <img src={image} alt={`Project Slide ${index}`} />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectGallery;